import type { ReactNode } from "react";
import Stack from "@mui/material/Stack";
import { gaps } from "../../../primitives/spacing";
import { PageTitle } from "../../../primitives/data-display/PageTitle";
import { Subtitle } from "../../../primitives/data-display/Subtitle";

interface AuthFormFrameProps {
  title?: string;
  subtitle?: string;
  /** Secondary action rendered below the body — links, back buttons. */
  footer?: ReactNode;
  children?: ReactNode;
}

/** The heading, body and footer of one auth form, laid out to sit inside `AuthLayout`. */
export function AuthFormFrame({ title, subtitle, footer, children }: AuthFormFrameProps) {
  return (
    <Stack gap={gaps.base}>
      {(title || subtitle) && (
        <Stack gap={gaps.tight}>
          {title && <PageTitle>{title}</PageTitle>}
          {subtitle && <Subtitle>{subtitle}</Subtitle>}
        </Stack>
      )}
      {children}
      {footer && <Stack alignItems="center">{footer}</Stack>}
    </Stack>
  );
}
